<template>
	<div
		v-if="isVisible"
		:class="[$style['message-bar'],
			{
				[$style['message-bar--no-radius']]: noRadius,
				[$style['message-bar--header']]: header,
				[$style['message-bar--' + type ]]: type
			}
		]"
	>
		<div :class="$style['message-bar__content']">
			<FontAwesomeIcon
				v-if="icon"
				:class="$style['message-bar__icon']"
				:icon="['far', icon]"
				size="lg"
			/>
			<span :class="$style['message-bar__message']">
				<slot />
			</span>
		</div>
		<BaseIconButton
			v-if="showClose"
			@click.prevent="close"
		>
			<FontAwesomeIcon
				:icon="['fal', 'times']"
				size="lg"
			/>
		</BaseIconButton>
	</div>
</template>
<script>
export default {
	name: 'MessageBar',
	props: {
		noRadius: {
			type: [String, Boolean],
			default: false
		},
		header: {
			type: Boolean,
			default: false
		},
		showClose: {
			type: [String, Boolean],
			default: false
		},
		type: {
			type: [String],
			default: 'warning',
			validator (value) {
				return ['success', 'primary', 'warning', 'danger'].indexOf(value) !== -1
			}
		}
	},
	data: () => ({
		isVisible: true
	}),
	computed: {
		icon () {
			switch (this.type) {
				case 'warning':
					return 'exclamation-triangle'
				case 'danger':
					return 'exclamation-circle'
				case 'success':
					return 'check-circle'
				default:
					return null
			}
		}
	},
	methods: {
		close () {
			this.isVisible = false
			this.$emit('hide-message-bar')
		}
	}
}
</script>
<style lang="scss" module>

.message-bar {
    display: flex;
    padding: $gutter * 2;
    color: getColor(text);
	background-color: getColor(surface);
    border-radius: 5px;
    font-size: 14px;
    justify-content: space-between;
    align-items: center;

    @include media-breakpoint-down(md) {
        padding: 20px;
    }

    &--header {
        padding: 10px 40px 10px 50px;

        @include media-breakpoint-only(xs) {
            padding: $gutter;
        }
    }

    &--no-radius {
        border-radius: 0;
    }

    &--warning {
        color: getColor(warning-text);
        background-color: getColor(warning-bg);

        a {
            color: inherit;

            &:hover {
                color: inherit;
                text-decoration: underline;
            }
        }
    }

    &--danger {
        color: getColor(white);
        background-color: getColor(danger);

        ::selection {
            color: getColor(danger);
            background-color: getColor(white);
        }

        a {
            color: inherit;

            &:hover {
                color: inherit;
                text-decoration: underline;
            }
        }
    }

    &--success {
        color: getColor(white);
        background-color: getColor(success);

        ::selection {
            color: getColor(success);
            background-color: getColor(white);
        }

        a {
            color: inherit;

            &:hover {
                color: inherit;
                text-decoration: underline;
            }
        }
    }

    &--primary {
        color: getColor(white);
        background-color: getColor(primary);

        ::selection {
            color: getColor(primary);
            background-color: getColor(white);
        }

        a {
            color: inherit;

            &:hover {
                color: inherit;
                text-decoration: underline;
            }
        }
    }

    &__icon {
        align-self: center;
        margin-right: $gutter;
    }

    &__content {
        align-self: center;
        display: flex;
    }
}
</style>
